import { useContext } from 'react';

import CrispContext from './CrispContext';

const useCrisp = () => useContext(CrispContext);

export default useCrisp;
